import { NgOptimizedImage } from "@angular/common";
import { Component, output } from "@angular/core";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "guest-landingpage",
  imports: [ButtonModule, NgOptimizedImage],
  templateUrl: "./guest-landingpage.component.html",
  styleUrl: "./guest-landingpage.component.css",
})
export class GuestLandingpageComponent {
  public login = output<void>();
}
